'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/badge/style/css');

var _badge = require('antd/lib/badge');

var _badge2 = _interopRequireDefault(_badge);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaListItem = _react2.default.createClass({
    displayName: 'MediaListItem',

    propTypes: {
        url: _react.PropTypes.string.isRequired,
        isSelected: _react.PropTypes.bool,
        onClick: _react.PropTypes.func
    },

    render: function render() {
        return _react2.default.createElement(
            'li',
            { onClick: this.props.onSelect },
            _react2.default.createElement(
                _badge2.default,
                { dot: this.props.isSelected },
                _react2.default.createElement('img', { src: this.props.url + '!160x160' })
            )
        );
    }
});

exports.default = MediaListItem;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/media_list_item.js
// module id = 1471
// module chunks = 0